import { render, staticRenderFns } from "./HighlightBrands.vue?vue&type=template&id=064d381c&"
import script from "./HighlightBrands.vue?vue&type=script&lang=js&"
export * from "./HighlightBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports